export default {
    imageDashboardSummary: {
        totalImagesGenerated: 'Total de imágenes generadas',
        cost: 'Costo',
        imagesPerDay: 'Imágenes/día',
    },
};
